
    
import { Component, Prop, Vue } from 'vue-property-decorator';  
import moment from 'moment';
import Form7 from "../files/Form7.vue";

@Component({
    components:{
        Form7
    }
})
export default class ProofOfServiceInstructionsOther extends Vue {

    @Prop({required: true})
    applicationId!: string;

    @Prop({default: false})
    mustProvide!: boolean;

    @Prop({required: true})
    instructionsStep!: string;    
    
    displayForm7 = false;
    
    public onPrint() { 
        const printId = "print-form7";
        const pdfName = "certificate-of-service-form-7";
        const pdf_type = 'TEMP';

        const el= document.getElementById(printId);
        const bottomLeftText = `"PFA 714  `+moment().format("MMMM D, YYYY")+ `\\a              Form 7";`;
        const bottomRightText = ``;
        
        const url = '/survey-print/'+this.applicationId+'/?name=' + pdfName + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );
        
        const body = {
            'html':pdfhtml,
            'json_data':null
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {
                this.onPrintSave(pdfName)
        },err => {
            console.error(err);        
        });
    }

    public onPrintSave(pdfName: string){        
        const url = '/survey-print/'+this.applicationId+'/?pdf_type=TEMP'
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName;
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);            
        },err => {
            console.error(err);
        });
    }    
}
